const ishiharaImageMap = import.meta.glob("/src/assets/images/ishihara/*.webp", {
  eager: true,
  import: "default",
}) as Record<string, string>;

// Small JPEG thumbnails for result/print views — the full-res webp plates
// inflate printed PDFs massively. Full-res stays for the live progress view.
const ishiharaThumbMap = import.meta.glob("/src/assets/images/ishihara/thumbs/*.jpg", {
  eager: true,
  import: "default",
}) as Record<string, string>;

const getPlateNumberFromPath = (imagePath: string): number =>
  Number.parseInt(
    imagePath
      .split("/")
      .pop()
      ?.replace(/\.(webp|jpg)$/, "") ?? "",
    10,
  );

const byPlateNumber = (imageMap: Record<string, string>): Map<number, string> =>
  new Map(Object.entries(imageMap).map(([path, url]) => [getPlateNumberFromPath(path), url]));

const sortedPlateNumbers = Object.keys(ishiharaImageMap)
  .map(getPlateNumberFromPath)
  .sort((left, right) => left - right);

const fullResByPlate = byPlateNumber(ishiharaImageMap);
const thumbByPlate = byPlateNumber(ishiharaThumbMap);

export const colorVisionPlateImages = sortedPlateNumbers.map(
  (plate) => fullResByPlate.get(plate) ?? "",
);

// Falls back to the full-res plate if a thumbnail is ever missing.
export const colorVisionPlateThumbImages = sortedPlateNumbers.map(
  (plate) => thumbByPlate.get(plate) ?? fullResByPlate.get(plate) ?? "",
);
